// 案例分类管理
import http from "@/jslibs/axios/http";

// 案例分类列表
export const list = (data) => http.get(`/v1/cms/MCaseCategory`, data);

// 案例分类添加
export const add = (data) => http.post(`/v1/cms/MCaseCategory`, data);

// 案例分类编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/MCaseCategory/${uuid}`, data);

// 案例分类详情
export const detail = ({ cuuid, ...data }) => http.get(`/v1/cms/MCaseCategory/${cuuid}`, data);

// 案例分类删除
export const del = ({ cuuid }) => http.delete(`/v1/cms/MCaseCategory/${cuuid}`);